<div
  class="main"
>
  <lse-header></lse-header>
      <ng-container>
          @if (isReady && isLoggedIn) {<lse-home [eToken]="eToken" [uMode]="uMode" [uAssigendStream]="uAssigendStream"></lse-home>}
          @else if (!isReady) {}
          @else {<lse-login></lse-login>}
      </ng-container>
  
  <lse-footer></lse-footer>
</div>



